module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_seminar_attendee-3fd7d4eaf7d5a6e96f0689b6d7f9f002.svg";